import React from 'react';
import { Grid, Switch, Typography } from '@mui/material';
import { currencyFormatter, formatDate } from 'helpers/formatHelper';
import { transformDateKeys } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/components/ValueByDate/helpers/apiHelpers';
import { DetailedEnvelopePayComponentHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Envelope/PayComponentHypothesis/helpers/types';
import { toggleExclusion } from '../../SimulationHome/components/SimulationModal/components/Duplication/helpers/dataHelpers';

type Props = {
    hypothesis: DetailedEnvelopePayComponentHypothesis;
    excludedPayComponentHypotheses?: number[];
    setExcludedPayComponentHypotheses?: (
        excludedPayComponentHypotheses: number[],
    ) => void;
};

const EnvelopePayComponentHypothesis = ({
    hypothesis,
    excludedPayComponentHypotheses,
    setExcludedPayComponentHypotheses,
}: Props): React.ReactElement => {
    const { id, newValuesByDates, payComponent, orgChartHrName } = hypothesis;
    const valuesByDates = transformDateKeys(newValuesByDates);

    const isExcluded = excludedPayComponentHypotheses
        ? excludedPayComponentHypotheses.includes(id)
        : false;

    return (
        <>
            {Object.entries(valuesByDates).map(([key, value]) => (
                <Grid container spacing={2} key={key}>
                    <Grid item xs={3}>
                        <Typography sx={{ textAlign: 'left' }} variant="body2">
                            {orgChartHrName}
                        </Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography
                            sx={{ textAlign: 'center' }}
                            variant="body1SemiBold"
                        >
                            {payComponent}
                        </Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography
                            sx={{ textAlign: 'center' }}
                            variant="body2"
                        >
                            {formatDate(new Date(key))}
                        </Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography
                            sx={{ textAlign: 'right', marginRight: '20px' }}
                            variant="body2"
                        >
                            {currencyFormatter(value)}
                        </Typography>
                    </Grid>
                    {excludedPayComponentHypotheses &&
                        setExcludedPayComponentHypotheses && (
                            <Grid
                                item
                                xs={2}
                                display="flex"
                                justifyContent="end"
                            >
                                <Switch
                                    checked={!isExcluded}
                                    onChange={() =>
                                        toggleExclusion(
                                            excludedPayComponentHypotheses,
                                            setExcludedPayComponentHypotheses,
                                            id,
                                            isExcluded,
                                        )
                                    }
                                />
                            </Grid>
                        )}
                </Grid>
            ))}
        </>
    );
};

export default EnvelopePayComponentHypothesis;
